function applyImageStyles() {
    return {
        display: "block",
        margin: "0",
        "max-width": "100%",
        height: "auto",
    };
}
const styles = {
    image: Object.assign({}, applyImageStyles()),
    image__picture: {
        display: "block",
    },
    image_img: Object.assign({}, applyImageStyles()),
};
export default styles;
